exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-title[data-v-37493342]{font-weight:800}.btn[data-v-37493342]{margin:10px;padding:0 16px}.remarks[data-v-37493342]{font-size:13px}.add-cart-btn[data-v-37493342]{margin-top:-13px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37493342","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/custom_sets.vue
// module id = mT+C
// module chunks = 0